export default __webpack_public_path__ + "static/media/submit.89d9354c.svg";